import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { API_BASE_URL } from '@synergy/config';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { BonusSettlementsDetailApi } from '../../api/bonus-settlements-detail-api';

const api = new BonusSettlementsDetailApi(API_BASE_URL);

export const bonusSettlementPoolDetailsReset = createAction('bonusSettlement/pool-customer-details-reset');
export const bonusSettlementPoolDetailSuppliersReset = createAction('bonusSettlement/pool-customer-suppliers-reset');

export const getPoolBonusSettlementCustomerSuppliers = createAsyncThunk(
    'bonusSettlement/pool-customer-suppliers',
    async (
        { id, customerId, searchParams }: { id: number; customerId: number; searchParams?: URLSearchParams },
        thunkAPI
    ) => {
        const response = await api.getPoolBonusSettlementCustomerSuppliers(id, customerId, searchParams);

        if (response.success) {
            return response.result;
        }
        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));

        return null;
    }
);

export const getPoolBonusSettlementCustomerDetails = createAsyncThunk(
    'bonusSettlement/pool-customer-details',
    async (
        { id, customerId, searchParams }: { id: number; customerId: number; searchParams?: URLSearchParams },
        thunkAPI
    ) => {
        const response = await api.getPoolBonusSettlementCustomerDetails(id, customerId, searchParams);

        if (response.success) {
            return response.result;
        }
        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));

        return null;
    }
);
